/**
 * Custom JavaScript for Newsletter Reminder Mobile Functionality
 * Handles tap-to-expand behavior on mobile devices
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const reminder = document.querySelector('newsletter-reminder');

    if (!reminder) return;

    // Mobile tap-to-expand functionality
    function handleMobileTap() {
      if (window.innerWidth <= 768) {
        // Add click listener for mobile
        reminder.addEventListener('click', function(e) {
          // If not expanded yet, expand it and prevent popup trigger
          if (!reminder.classList.contains('expanded')) {
            e.preventDefault();
            e.stopPropagation();
            reminder.classList.add('expanded');
          }
          // If already expanded, let the original click handler work (opens popup)
        });

        // Close when clicking outside
        document.addEventListener('click', function(e) {
          if (reminder.classList.contains('expanded') && !reminder.contains(e.target)) {
            reminder.classList.remove('expanded');
          }
        });

        // Close on escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && reminder.classList.contains('expanded')) {
            reminder.classList.remove('expanded');
          }
        });
      }
    }

    // Initialize on load
    handleMobileTap();

    // Re-initialize on resize (with debounce)
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Remove expanded class if switching to desktop
        if (window.innerWidth > 768) {
          reminder.classList.remove('expanded');
        }
      }, 250);
    });
  });
})();

(function() {
  'use strict';

  function labelJudgeMeArrows(root) {
    var scope = root || document;
    var arrows = scope.querySelectorAll('.jdgm-arrow:not([aria-label])');

    arrows.forEach(function(button) {
      var onclick = button.getAttribute('onclick') || '';
      if (onclick.indexOf('Previous') !== -1 || button.className.indexOf('prev') !== -1) {
        button.setAttribute('aria-label', 'Previous review');
      } else if (onclick.indexOf('Next') !== -1 || button.className.indexOf('next') !== -1) {
        button.setAttribute('aria-label', 'Next review');
      } else {
        button.setAttribute('aria-label', 'Review carousel control');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    labelJudgeMeArrows(document);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            labelJudgeMeArrows(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
